import text from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { Link } from 'foundations-components/transitional/components/Link';
import ImageLoadingTypes from 'ContentUtils/constants/ImageLoadingTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.image.${key}`;
const LoadingSelect = ({
  onChange,
  readOnly,
  useOnDark,
  value
}) => {
  const lazyLoadingOptions = [{
    text: text(i18nKey('lazyLoading.disabled')),
    value: ImageLoadingTypes.DISABLED
  }, {
    text: text(i18nKey('lazyLoading.lazy')),
    value: ImageLoadingTypes.LAZY
  }, {
    text: text(i18nKey('lazyLoading.eager')),
    value: ImageLoadingTypes.EAGER
  }];
  const onLazyLoadingChange = e => {
    onChange(e.target.value);
  };
  const learnMoreLink = /*#__PURE__*/_jsx(Link, {
    href: 'https://web.dev/browser-level-image-lazy-loading/',
    external: true,
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey('lazyLoading.learnMore')
    })
  });
  return /*#__PURE__*/_jsx(FormControl, {
    tooltipPlacement: 'top',
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('lazyLoading.label')
    }),
    tooltip: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey('lazyLoading.loadingValueHelp'),
      options: {
        learnMoreLink
      }
    }),
    marginBlockStart: "200",
    children: /*#__PURE__*/_jsx(Select, {
      buttonUse: useOnDark ? 'form-on-dark' : 'form',
      onChange: onLazyLoadingChange,
      options: lazyLoadingOptions,
      readOnly: readOnly,
      value: value || ImageLoadingTypes.DISABLED
    })
  });
};
export default LoadingSelect;